import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, isRef as _isRef, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, Fragment as _Fragment, normalizeClass as _normalizeClass, renderList as _renderList } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-center",
  style: {"min-height":"200px","display":"flex","align-items":"center","justify-content":"center"}
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "me-2" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "mt-4" }
const _hoisted_8 = {
  key: 1,
  class: "breadcrumbs mb-1"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["id"]
const _hoisted_11 = ["id"]
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { key: 2 }
const _hoisted_15 = ["id"]
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { key: 4 }
const _hoisted_19 = { class: "mt-4" }
const _hoisted_20 = { key: 5 }
const _hoisted_21 = { class: "mt-4" }
const _hoisted_22 = { key: 6 }
const _hoisted_23 = { class: "mt-4" }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { class: "mt-4" }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { key: 1 }
const _hoisted_29 = { class: "mt-4" }
const _hoisted_30 = { key: 2 }
const _hoisted_31 = { class: "mt-4" }
const _hoisted_32 = { key: 2 }
const _hoisted_33 = { key: 3 }
const _hoisted_34 = { key: 4 }
const _hoisted_35 = { key: 5 }
const _hoisted_36 = { key: 6 }
const _hoisted_37 = { key: 7 }
const _hoisted_38 = { key: 0 }
const _hoisted_39 = { key: 1 }

import { ref, computed, reactive, watch, watchEffect } from 'vue';
import { useQuery, useMutation, useApolloClient } from '@vue/apollo-composable';
import {
  BucketDetailsDocument,
  BucketType,
  DataObjectType,
  SamplesAutoAnnotateDocument,
  SampleNamesFromFilesDocument,
  UserType,
} from '@/gql/graphql';
import {
  BAlert,
  BButton,
  BButtonGroup,
  BCard,
  BCollapse,
  BContainer,
  BFormCheckbox,
  BModal,
  BSpinner,
  BTable,
  BTooltip,
} from 'bootstrap-vue-next';
import { getFileDownloadUrl } from '@/utils/fileService';
import { formatFileSize, formatFileName } from '@/utils/file-utils';
import { isBclRunArchive } from '@/utils/bcl-to-fastq-input';
import { deepParseDates, formatDate } from '@/utils/date-utils';
import { truncateText } from '@/utils/string-utils';
import DataObjectRename from '@/components/data/DataObjectRename.vue';
import DataObjectDetail from '@/components/data/DataObjectDetail.vue';
import DataObjectDelete from '@/components/data/DataObjectDelete.vue';
import ProjectList, {
  ProjectTypeExtended,
} from '@/components/project/ProjectList.vue';
import SampleForm from '@/components/sample/SampleForm.vue';
import SampleList, {
  SampleTypeExtended,
} from '@/components/sample/SampleList.vue';
import {
  BUCKET_DATA_TYPES,
  IS_DEBUG_MODE,
  SHARING_USER_ROLES,
  TRUNCATE_TEXT_LENGTH,
} from '@/constants';
import BucketUserAssociationCreate from '@/components/data/BucketUserAssociationCreate.vue';
import BucketUserAssociationDelete from '@/components/data/BucketUserAssociationDelete.vue';
import BucketUpdate from '@/components/data/BucketUpdate.vue';
import BucketDelete from '@/components/data/BucketDelete.vue';
import ComputeTaskList from '@/components/compute/ComputeTaskList.vue';
import BclToFastqNew from '@/components/compute/BclToFastqNew.vue';
import { useUserStore } from '@/store/user';
import { useRouter } from 'vue-router';

interface BreadCrumbItem {
  path: string;
  name: string;
}
interface SelectableDataObjectType extends DataObjectType {
  isSelectable: boolean;
  selected: boolean;
}

// --- Local States ---
//const storageBucket = ref<BucketType | null>(null);

export default /*@__PURE__*/_defineComponent({
  __name: 'DataBrowser',
  props: {
    bucketId: {},
    showMetadata: { type: Boolean },
    role: {},
    allowDownload: { type: Boolean },
    listComputeTasks: { type: Boolean },
    listSamples: { type: Boolean },
    listProjects: { type: Boolean },
    listUsers: { type: Boolean },
    pathPrefix: {}
  },
  emits: ['update:pathPrefix', 'bucketDeleted'],
  setup(__props: any, { emit: __emit }) {

const userStore = useUserStore();
const router = useRouter();
const { resolveClient } = useApolloClient();

// --- Component references ---
const computeTaskList = ref<InstanceType<typeof ComputeTaskList>>();

// --- Component properties ---
const props = __props;

const emits = __emit;

const canEdit = computed(() => {
  return (
    props.role === SHARING_USER_ROLES.OWNER ||
    props.role === SHARING_USER_ROLES.EDITOR
  );
});

// --- Define Interfaces for BreadCrumbItem and SelectableDataObjectType ---
const showAdvancedFeatures = ref(false);
const showBucketUpdateModal = ref(false);
const showBucketDeleteModal = ref(false);
const showBucketExpirationModal = ref(false);
const showBucketUserAssociationCreateModal = ref(false);
const showBucketUserAssociationDeleteModal = ref(false);
const showCompleteDescription = ref(false);
const selectedUser = ref<UserType | null>(null);
const selectableDataObjects = ref<SelectableDataObjectType[]>([]);
const currentPathBreadCrumbs = computed(() => {
  let breadCrumbs: Array<BreadCrumbItem> = [];
  if (storageBucket.value?.name) {
    breadCrumbs.push({
      path: '',
      name: storageBucket.value.friendlyName
        ? storageBucket.value.friendlyName
        : storageBucket.value?.name,
    });
  }
  const pathParts = props.pathPrefix.split('/').filter((part) => part) ?? [];
  for (let i = 0; i < pathParts.length; i++) {
    const path = pathParts.slice(0, i + 1).join('/') + '/';
    const name = pathParts[i];
    breadCrumbs.push({
      path: path,
      name: name,
    });
  }
  return breadCrumbs;
});

// --- Storage objects selection (details, rename, download, delete) ---
const selectedDataObject = ref<SelectableDataObjectType | null>(null);
const DataObjectNameUpdate = ref('');
const showModalDataObjectDetail = ref(false);
const showModalDataObjectRename = ref(false);
const showModalDataObjectDelete = ref(false);
const showModalSampleCreate = ref(false);
const showModalBclToFastq = ref(false);

const selectedDataObjectPreviewEnabled = computed(() => {
  // if allowDownload is true, then allow preview
  if (props.allowDownload) {
    return true;
  }
  // otherwise only allow preview for the selected text files
  if (selectedDataObject.value && selectedDataObject.value.name) {
    return (
      selectedDataObject.value.name?.endsWith('.html') ||
      selectedDataObject.value.name?.endsWith('.htm') ||
      selectedDataObject.value.name?.endsWith('.log') ||
      selectedDataObject.value.name?.endsWith('.txt') ||
      selectedDataObject.value.name?.endsWith('.csv') ||
      selectedDataObject.value.name?.endsWith('.json') ||
      selectedDataObject.value.name?.endsWith('.tsv') ||
      selectedDataObject.value.name?.endsWith('.xml') ||
      selectedDataObject.value.name?.endsWith('.yml') ||
      selectedDataObject.value.name?.endsWith('.yaml') ||
      selectedDataObject.value.name?.endsWith('.md') ||
      selectedDataObject.value.name?.endsWith('.sql') ||
      selectedDataObject.value.name?.endsWith('.pdf')
    );
  }
  // otherwise, return false
  return false;
});

const newSampleName = ref('');
const newSampleDescription = ref('');
const newSampleFileR1 = ref('');
const newSampleFileR2 = ref('');
const newSampleKitCode = ref('');
const newSampleWarning = ref<string | null>(null);

const newSampleError = ref<string | null>(null);
const newSampleQueryInProgress = ref(false);
const newSampleEnabled = computed(() => selectedDataObjects.value.length === 2);

const bclToFastqEnabled = computed(() => {
  if (selectedDataObjects.value.length === 1) {
    return isBclRunArchive(selectedDataObjects.value[0]?.name);
  } else if (selectedDataObjects.value.length === 2) {
    let hasBcl = false;
    let hasCsv = false;
    for (const sObj of selectedDataObjects.value) {
      if (sObj.name && isBclRunArchive(sObj.name)) {
        hasBcl = true;
      } else if (sObj.name && sObj.name.toLowerCase().endsWith('csv')) {
        hasCsv = true;
      }
    }
    return hasBcl && hasCsv;
  }
  return false;
});

const conversionFileBcl = computed(() => {
  for (const sObj of selectedDataObjects.value) {
    if (sObj.name && isBclRunArchive(sObj.name)) {
      return sObj.name;
    }
  }
  return null;
});

const conversionFileCsv = computed(() => {
  for (const sObj of selectedDataObjects.value) {
    if (sObj.name && sObj.name.toLowerCase().endsWith('csv')) {
      return sObj.name;
    }
  }
  return null;
});

const conversionDefaultName = ref('BCL to FASTQ conversion');

function setConversionDefaultName() {
  let defaultName = 'BCL to FASTQ conversion 1';
  let taskNo = 1;
  let nameUnique = false;
  while (!nameUnique) {
    defaultName = `BCL to FASTQ conversion ${taskNo}`;
    nameUnique = !computeTaskList.value?.tasks.some(
      (obj) => obj.name === defaultName
    );
    taskNo++;
  }
  conversionDefaultName.value = defaultName;
}

// --- Table Fields ---
const fileTableFields = [
  {
    key: 'id',
    label: '',
    tdClass: 'align-middle min-width',
    thClass: 'min-width',
    width: '1px',
  },
  {
    key: 'name',
    label: 'Name',
    sortable: true,
    formatter: formatFileName,
    tdClass: 'align-middle',
  },
  {
    key: 'size',
    label: 'Size',
    sortable: true,
    formatter: formatFileSize,
    tdClass: 'align-middle',
  },
  {
    key: 'updatedAt',
    label: 'Last updated',
    sortable: true,
    tdClass: 'align-middle',
  },
  { key: 'actions', label: '', tdClass: 'align-middle text-end' },
];

// --- Query the bucket's files ---
const {
  result: result,
  loading: loading,
  error: error,
  refetch: refetch,
} = useQuery(
  BucketDetailsDocument,
  {
    bucketId: props.bucketId,
    pathPrefix: props.pathPrefix,
  },
  {
    fetchPolicy: 'no-cache',
  }
);

function requestRefetchDetails(bucketId: number, pathPrefix: string) {
  console.debug('Refetching', pathPrefix);
  refetch({
    bucketId: bucketId,
    pathPrefix: pathPrefix,
  })
    ?.catch((err) => {
      console.error('Refetch failed:', err);
    })
    ?.then(() => {
      console.log('Bucket details refetched');
    });
}

// --- Re-run the query whenever path changes ---
watch(
  () => props.pathPrefix,
  (newPath) => {
    requestRefetchDetails(props.bucketId, newPath);
  }
);

const storageBucket = computed(() => {
  return result.value?.bucket
    ? (deepParseDates(result.value.bucket) as BucketType)
    : null;
});

const isSystemBucket = computed(() => {
  return storageBucket.value?.dataType === BUCKET_DATA_TYPES.SYSTEM;
});

// When storageBucket.value or props.pathPrefix change, update the reactive state
watchEffect(() => {
  if (result.value && storageBucket.value && storageBucket.value.dataObjects) {
    // Create a new array based on the latest data
    selectableDataObjects.value = storageBucket.value.dataObjects
      .filter((obj) => obj && obj.name !== props.pathPrefix)
      .map((obj) =>
        reactive({
          ...obj,
          isSelectable: true,
          selected: false, // default value, mutable later with checkbox events
        })
      );
    // If we're not at the root, add a synthetic parent folder row.
    if (props.pathPrefix) {
      selectableDataObjects.value.unshift({
        id: '-1',
        name: '..',
        isFolder: true,
        size: null,
        updatedAt: null,
        isSelectable: false,
        selected: false,
      });
    }
  } else {
    selectableDataObjects.value = [];
  }
});

const selectedDataObjects = computed<SelectableDataObjectType[]>(() => {
  console.debug(
    'Selected data objects:',
    selectableDataObjects.value.filter((obj) => obj.selected)
  );
  return selectableDataObjects.value.filter((obj) => obj.selected);
});

const noDataObjects = computed(() => {
  return selectableDataObjects.value.length === 0;
});

const samples = computed<SampleTypeExtended[]>(() => {
  const sList: SampleTypeExtended[] = [];
  storageBucket.value?.samples?.forEach((sample) => {
    if (sample) {
      sList.push({
        ...sample,
        canEdit: canEdit.value,
      });
    }
  });
  return sList;
});

const projects = computed<ProjectTypeExtended[]>(() => {
  let projects: ProjectTypeExtended[] = [];
  // iterate through sample and their associated projects
  for (const sample of samples.value) {
    for (const assoc of sample.projectsAssociated ?? []) {
      if (assoc?.project) {
        // only add the project if project with the same ID is not yet in the collection
        if (!projects.find((p) => p.id === assoc.project?.id)) {
          projects.push({
            ...assoc?.project,
            canEdit: false, // no need for delete button
          });
        }
      }
    }
  }
  // return projects
  return projects;
});

// --- Handle Storage Object Actions / Bucket Browsing ---
function updatePathPrefix(path: string, evt?: MouseEvent) {
  // Ctrl (Win/Linux) or Cmd (macOS) → open in new tab
  // Also support middle-click if it bubbles as a click (evt.button === 1)
  if (evt && (evt.ctrlKey || evt.metaKey || evt.button === 1)) {
    const to = {
      name: 'BucketDetail',
      params: {
        id: props.bucketId,
      },
      query: path ? { path } : undefined, // put the folder path in query
    };
    const url = router.resolve(to).href;
    window.open(url, '_blank', 'noopener'); // new tab, no opener
    evt.preventDefault();
    return;
  }

  // Normal left-click → navigate in-place by emitting the event
  emits('update:pathPrefix', path);
  console.debug('Updating path prefix to:', path);
}

function openFolder(folderName: string, evt?: MouseEvent) {
  // emits('update:pathPrefix', folderName);
  console.debug('Opening folder:', folderName);
  updatePathPrefix(folderName, evt);
}

function goUpOneFolder(evt?: MouseEvent) {
  // check if we are at the root
  if (!props.pathPrefix) return;
  // go up one folder
  const parts = props.pathPrefix.split('/');
  parts.pop(); // removes last empty part
  parts.pop(); // removes last folder
  if (parts.length === 0) {
    // emits('update:pathPrefix', '');
    console.debug('Going up to root');
    updatePathPrefix('', evt);
    return;
  }
  // emits('update:pathPrefix', parts.join('/') + '/'); // always add trailing slash
  console.debug('Going up to:', props.pathPrefix);
  updatePathPrefix(parts.join('/') + '/', evt); // always add trailing slash
}

function handleDataObjectDetailRequest(
  DataObject: SelectableDataObjectType,
  evt?: MouseEvent
) {
  console.log('Clicked on object:', DataObject);
  if (DataObject.isFolder) {
    if (DataObject.name) {
      openFolder(DataObject.name, evt);
    } else {
      console.error('No folder name found in object:', DataObject);
    }
  } else {
    selectedDataObject.value = DataObject;
    showModalDataObjectDetail.value = true;
  }
}

function dataRowClicked(
  dataObject: SelectableDataObjectType,
  index?: number,
  evt?: MouseEvent
) {
  // check if the object is a folder
  if (dataObject.name === '..') {
    // if it is the parent folder, go up one folder
    goUpOneFolder(evt);
  } else if (dataObject.isFolder && dataObject.name) {
    // if it is a folder, open it
    openFolder(dataObject.name, evt);
  } else if (!dataObject.isFolder) {
    // if it is a file, show the details
    handleDataObjectDetailRequest(dataObject, evt);
  }
}

async function handleDataObjectDownloadRequest(
  DataObject: SelectableDataObjectType
) {
  // validate the selected data object
  if (!DataObject.name) {
    console.error('No name found in selected data object');
    return;
  }
  // fetch the download URL
  const url = await getFileDownloadUrl(props.bucketId, DataObject.name);
  if (!url) {
    console.error(
      `Unexpected error fetching download URL for the file ${DataObject.name}`
    );
    alert(
      'Failed to generate download link. The requested file might not be available anymore.'
    );
    return;
  }
  // Open the URL in a new tab to trigger the download.
  window.open(url, '_blank');
}

function handleDataObjectRenameRequest(DataObject: SelectableDataObjectType) {
  if (DataObject.name) {
    selectedDataObject.value = DataObject;
    DataObjectNameUpdate.value = formatFileName(DataObject.name);
    showModalDataObjectRename.value = true;
  } else {
    console.error(
      'Storage object rename requested, but no name found in object:',
      DataObject
    );
  }
}

function handleDataObjectDeleteRequest(DataObject: SelectableDataObjectType) {
  selectedDataObject.value = DataObject;
  showModalDataObjectDelete.value = true;
}

function refreshRequested() {
  requestRefetchDetails(props.bucketId, props.pathPrefix);
}

function onDataObjectRenameSuccess() {
  closeModals();
  requestRefetchDetails(props.bucketId, props.pathPrefix);
}

function onDataObjectDeleteSuccess() {
  closeModals();
  requestRefetchDetails(props.bucketId, props.pathPrefix);
}

function onSampleFormSuccess() {
  closeModals();
  requestRefetchDetails(props.bucketId, props.pathPrefix);
}

function handleDataObjectsSelectionDelete() {
  // TODO: Implement the batch delete logic here
  alert('Batch delete not implemented');
}

// -- Sample Auto-Annotation Action ---
const annotationMutationInProgress = ref(false);
const annotationMutationShowSuccess = ref(false);
const annotationMutationError = ref<string | null>(null);

const {
  mutate: executeSampleAutoAnnotationMutation,
  onDone: onSampleAutoAnnotationDone,
  onError: onSampleAutoAnnotationError,
} = useMutation(SamplesAutoAnnotateDocument);

onSampleAutoAnnotationDone((res) => {
  annotationMutationInProgress.value = false;
  if (res.data && res.data.samplesAutoAnnotate) {
    console.debug(
      'Sample auto-annotation successful:',
      res.data.samplesAutoAnnotate
    );
    annotationMutationShowSuccess.value = true;
    setTimeout(() => {
      annotationMutationShowSuccess.value = false;
      requestRefetchDetails(props.bucketId, props.pathPrefix);
    }, 1000);
  } else {
    annotationMutationError.value =
      'Sample auto-annotation failed: ' + res.data;
    console.error('Sample auto-annotation failed:', res.data);
  }
});

onSampleAutoAnnotationError((err) => {
  console.error('Error occured while auto-annotating samples:', err);
  annotationMutationInProgress.value = false;
  annotationMutationError.value = err.message;
});

function handleSampleAutoAnnotation() {
  console.debug('Sample auto-annotation requested');

  annotationMutationInProgress.value = true;
  annotationMutationError.value = null;

  const filesForAnnotation: string[] = [];

  if (selectedDataObjects.value.length > 0) {
    selectedDataObjects.value
      .filter((obj) => !obj.isFolder && obj.name)
      .forEach((obj) => {
        if (obj.name) {
          filesForAnnotation.push(obj.name);
        }
      });
  }

  executeSampleAutoAnnotationMutation({
    bucketId: props.bucketId,
    pathPrefix: props.pathPrefix,
    recursive: false,
    files: filesForAnnotation.length > 0 ? filesForAnnotation : null,
  });
}

// -- BCL to FASTQ conversion action ---
function handleBclToFastq() {
  console.debug('BCL to FASTQ conversion requested');
  setConversionDefaultName();
  showModalBclToFastq.value = true;
}

// --- Bucket Expiration Action ---
function handleBucketExpirationDetailRequest() {
  showBucketExpirationModal.value = true;
}

// --- New Sample Action ---
async function handleNewSample() {
  newSampleWarning.value = newSampleError.value = null;
  newSampleName.value = newSampleDescription.value = '';
  const files = selectedDataObjects.value.map((obj) => obj.name || '');
  [newSampleFileR1.value, newSampleFileR2.value] = files;
  newSampleQueryInProgress.value = true;
  try {
    const { data } = await resolveClient().query({
      query: SampleNamesFromFilesDocument,
      variables: { files },
      fetchPolicy: 'no-cache',
    });
    const preview = data.sampleNamesFromFiles;
    if (!preview) throw new Error('Could not preview sample names. Try again.');
    const [sample] = preview.samples;
    if (preview.samples.length > 1) {
      newSampleError.value = 'Selected files belong to different samples.';
    } else if (sample?.fileR1 && sample.fileR2) {
      newSampleName.value = sample.name;
      newSampleFileR1.value = sample.fileR1;
      newSampleFileR2.value = sample.fileR2;
    } else if (preview.unmatchedFiles.length) {
      newSampleWarning.value =
        'Could not determine sample name. Enter a name and check the R1/R2 files.';
    } else {
      newSampleError.value = 'Selected files must contain one R1 and one R2.';
    }
  } catch (error) {
    newSampleError.value = (error as Error).message;
  } finally {
    newSampleQueryInProgress.value = false;
  }
  // set default kit code based on the storage coupon codes used
  console.debug(
    'Coupons associated with bucket:',
    storageBucket.value?.couponsAssociated
  );
  const storageCouponAssociation = storageBucket.value?.couponsAssociated?.find(
    (assoc) =>
      assoc &&
      assoc.coupon &&
      assoc.coupon.code &&
      assoc.coupon.couponType === 'storage' &&
      (!assoc.coupon.expiresAt || assoc.coupon.expiresAt >= Date.now())
  );
  console.debug(
    'Default coupon association to be used with the upload:',
    storageCouponAssociation
  );
  newSampleKitCode.value = storageCouponAssociation?.coupon?.code?.code || '';
  // show the new sample modal
  showModalSampleCreate.value = true;
}

function closeModals() {
  // close all storage objects modals
  showModalDataObjectDetail.value = false;
  showModalDataObjectRename.value = false;
  showModalDataObjectDelete.value = false;
  showModalSampleCreate.value = false;
  showBucketUserAssociationCreateModal.value = false;
  showBucketUserAssociationDeleteModal.value = false;
  showBucketUpdateModal.value = false;
  showBucketDeleteModal.value = false;
  showModalBclToFastq.value = false;
  showBucketExpirationModal.value = false;

  // reset selected file and sample
  selectedDataObject.value = null;
  selectedUser.value = null;
  newSampleName.value = '';
}

function bucketUserAssociationDeleteRequested(user: UserType) {
  selectedUser.value = user;
  showBucketUserAssociationDeleteModal.value = true;
}

function onBucketSharingChangedSuccess() {
  closeModals();
  requestRefetchDetails(props.bucketId, props.pathPrefix);
}

function onBucketUpdatedSuccess() {
  closeModals();
  requestRefetchDetails(props.bucketId, props.pathPrefix);
}

function onBucketDeletedSuccess() {
  closeModals();
  emits('bucketDeleted');
}

function onBclToFastqSuccess() {
  closeModals();
  requestRefetchDetails(props.bucketId, props.pathPrefix);
}

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_b_tooltip = _resolveDirective("b-tooltip")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(BAlert), {
      modelValue: _unref(error),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(error) ? (error).value = $event : null)),
      show: "",
      variant: "danger"
    }, {
      default: _withCtx(() => [
        _createTextVNode(" An error occurred while loading bucket data: " + _toDisplayString(_unref(error)?.message), 1)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (_unref(loading))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_unref(BSpinner), { label: "Loading data..." })
        ]))
      : (storageBucket.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (props.showMetadata)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("h1", null, [
                    _createVNode(_component_font_awesome_icon, {
                      icon: ['fas', 'database'],
                      class: "me-2"
                    }),
                    _createElementVNode("span", _hoisted_3, _toDisplayString(storageBucket.value.friendlyName), 1),
                    _createVNode(_unref(BButtonGroup), { class: "p-0 link-dark align-baseline btn-xs" }, {
                      default: _withCtx(() => [
                        (canEdit.value)
                          ? _withDirectives((_openBlock(), _createBlock(_unref(BButton), {
                              key: 0,
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (showBucketUpdateModal.value = true)),
                              title: "Edit Bucket Details",
                              variant: "dark"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_font_awesome_icon, { icon: ['fas', 'pencil'] })
                              ]),
                              _: 1
                            })), [
                              [
                                _directive_b_tooltip,
                                void 0,
                                void 0,
                                { hover: true }
                              ]
                            ])
                          : _createCommentVNode("", true),
                        (!isSystemBucket.value)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              (props.role === _unref(SHARING_USER_ROLES).OWNER)
                                ? (_openBlock(), _createBlock(_unref(BButton), {
                                    key: 0,
                                    variant: "warning"
                                  }, {
                                    default: _withCtx(() => [
                                      _cache[14] || (_cache[14] = _createElementVNode("i", { class: "fas fa-crown" }, null, -1)),
                                      _createTextVNode(" " + _toDisplayString(props.role), 1)
                                    ]),
                                    _: 1
                                  }))
                                : (props.role === _unref(SHARING_USER_ROLES).EDITOR)
                                  ? (_openBlock(), _createBlock(_unref(BButton), {
                                      key: 1,
                                      variant: "danger"
                                    }, {
                                      default: _withCtx(() => [
                                        _cache[15] || (_cache[15] = _createElementVNode("i", { class: "fas fa-pencil" }, null, -1)),
                                        _createTextVNode(" " + _toDisplayString(props.role), 1)
                                      ]),
                                      _: 1
                                    }))
                                  : (_openBlock(), _createBlock(_unref(BButton), {
                                      key: 2,
                                      variant: "success"
                                    }, {
                                      default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                                        _createElementVNode("i", { class: "fas fa-eye" }, null, -1),
                                        _createTextVNode(" viewer ", -1)
                                      ]))]),
                                      _: 1
                                    })),
                              _withDirectives((_openBlock(), _createBlock(_unref(BButton), {
                                variant: "secondary",
                                title: "Creation Date"
                              }, {
                                default: _withCtx(() => [
                                  _cache[17] || (_cache[17] = _createElementVNode("i", { class: "fas fa-calendar" }, null, -1)),
                                  _createTextVNode(" " + _toDisplayString(_unref(formatDate)(storageBucket.value.createdAt)), 1)
                                ]),
                                _: 1
                              })), [
                                [
                                  _directive_b_tooltip,
                                  void 0,
                                  void 0,
                                  { hover: true }
                                ]
                              ]),
                              (storageBucket.value.expiresAt)
                                ? _withDirectives((_openBlock(), _createBlock(_unref(BButton), {
                                    key: 3,
                                    onClick: handleBucketExpirationDetailRequest,
                                    variant: 
                  storageBucket.value.expiresAt &&
                  storageBucket.value.expiresAt - Date.now() < 7 * 24 * 60 * 60 * 1000
                    ? 'danger'
                    : 'secondary'
                ,
                                    title: "Expiration Date",
                                    style: {"border-left":"1px solid rgba(255, 255, 255, 0.3)"}
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_font_awesome_icon, { icon: ['fas', 'hourglass-end'] }),
                                      _createTextVNode(" " + _toDisplayString(_unref(formatDate)(storageBucket.value.expiresAt)), 1)
                                    ]),
                                    _: 1
                                  }, 8, ["variant"])), [
                                    [
                                      _directive_b_tooltip,
                                      void 0,
                                      void 0,
                                      { hover: true }
                                    ]
                                  ])
                                : _createCommentVNode("", true)
                            ], 64))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _cache[18] || (_cache[18] = _createElementVNode("hr", null, null, -1)),
                  (storageBucket.value.description)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_4, [
                        _createTextVNode(_toDisplayString(showCompleteDescription.value
              ? storageBucket.value.description
              : _unref(truncateText)(storageBucket.value.description, _unref(TRUNCATE_TEXT_LENGTH))) + " ", 1),
                        (
              canEdit.value &&
              (showCompleteDescription.value ||
                storageBucket.value.description.length <= _unref(TRUNCATE_TEXT_LENGTH))
            )
                          ? (_openBlock(), _createBlock(_unref(BButton), {
                              key: 0,
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (showBucketUpdateModal.value = true)),
                              variant: "link",
                              class: "p-0 ms-2 link-dark align-baseline",
                              size: "sm"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_font_awesome_icon, { icon: ['fas', 'pencil'] })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (storageBucket.value.description.length > _unref(TRUNCATE_TEXT_LENGTH))
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              (!showCompleteDescription.value)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_5, " "))
                                : (_openBlock(), _createElementBlock("br", _hoisted_6)),
                              _createVNode(_unref(BButton), {
                                variant: "link",
                                class: _normalizeClass(["p-0 align-baseline link-secondary text-decoration-underline", { 'mt-2': showCompleteDescription.value }]),
                                onClick: _cache[3] || (_cache[3] = ($event: any) => (showCompleteDescription.value = !showCompleteDescription.value)),
                                "aria-expanded": showCompleteDescription.value
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(showCompleteDescription.value ? 'Show Less' : 'Show More'), 1)
                                ]),
                                _: 1
                              }, 8, ["class", "aria-expanded"])
                            ], 64))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (
            canEdit.value &&
            showBucketUpdateModal.value &&
            storageBucket.value &&
            storageBucket.value.name
          )
                    ? (_openBlock(), _createBlock(BucketUpdate, {
                        key: 1,
                        show: showBucketUpdateModal.value,
                        bucketId: props.bucketId,
                        bucketName: storageBucket.value.name,
                        bucketFriendlyName: storageBucket.value.friendlyName || '',
                        bucketDescription: storageBucket.value.description || '',
                        onClose: _cache[4] || (_cache[4] = ($event: any) => (showBucketUpdateModal.value = false)),
                        onCloseAndRefresh: onBucketUpdatedSuccess
                      }, null, 8, ["show", "bucketId", "bucketName", "bucketFriendlyName", "bucketDescription"]))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true),
            _createElementVNode("h5", _hoisted_7, [
              _createVNode(_component_font_awesome_icon, {
                icon: "folder",
                class: "me-1"
              }),
              _cache[19] || (_cache[19] = _createTextVNode(" Files ", -1))
            ]),
            (currentPathBreadCrumbs.value.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentPathBreadCrumbs.value, (crumb, index) => {
                    return (_openBlock(), _createElementBlock("span", {
                      key: crumb.path
                    }, [
                      _createElementVNode("a", {
                        onClick: ($event: any) => (openFolder(crumb.path)),
                        style: {"cursor":"pointer"}
                      }, _toDisplayString(crumb.name), 9, _hoisted_9),
                      (index < currentPathBreadCrumbs.value.length - 1)
                        ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                            key: 0,
                            size: "sm",
                            icon: "angle-right",
                            class: "mx-1"
                          }))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (storageBucket.value)
              ? (_openBlock(), _createBlock(_unref(BContainer), {
                  key: 2,
                  id: `toolbar-bucket-${storageBucket.value.id}`,
                  class: "file-toolbar d-flex flex-wrap align-items-center gap-1 px-1 py-1",
                  fluid: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(BButton), {
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (requestRefetchDetails(props.bucketId, __props.pathPrefix))),
                      variant: "primary",
                      size: "sm"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_font_awesome_icon, { icon: "sync" }),
                        _cache[20] || (_cache[20] = _createTextVNode(" Refresh ", -1))
                      ]),
                      _: 1
                    }),
                    (!isSystemBucket.value)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (props.listUsers && canEdit.value)
                            ? (_openBlock(), _createBlock(_unref(BButton), {
                                key: 0,
                                onClick: _cache[6] || (_cache[6] = ($event: any) => (showBucketUserAssociationCreateModal.value = true)),
                                variant: "primary",
                                size: "sm"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_font_awesome_icon, { icon: "user-plus" }),
                                  _cache[21] || (_cache[21] = _createTextVNode(" Share Data ", -1))
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          _createElementVNode("span", {
                            id: `btn-new-sample-${storageBucket.value.id}`
                          }, [
                            (
                canEdit.value && storageBucket.value.dataType === _unref(BUCKET_DATA_TYPES).INPUT
              )
                              ? (_openBlock(), _createBlock(_unref(BButton), {
                                  key: 0,
                                  onClick: handleNewSample,
                                  variant: "primary",
                                  size: "sm",
                                  disabled: !newSampleEnabled.value || newSampleQueryInProgress.value
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_font_awesome_icon, { icon: "plus" }),
                                    _cache[22] || (_cache[22] = _createTextVNode(" New Sample ", -1))
                                  ]),
                                  _: 1
                                }, 8, ["disabled"]))
                              : _createCommentVNode("", true)
                          ], 8, _hoisted_10),
                          _createElementVNode("span", {
                            id: `btn-auto-annotate-samples-${storageBucket.value.id}`
                          }, [
                            (
                canEdit.value && storageBucket.value.dataType === _unref(BUCKET_DATA_TYPES).INPUT
              )
                              ? (_openBlock(), _createBlock(_unref(BButton), {
                                  key: 0,
                                  onClick: handleSampleAutoAnnotation,
                                  variant: "primary",
                                  size: "sm",
                                  disabled: annotationMutationInProgress.value
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_font_awesome_icon, { icon: "wand-magic-sparkles" }),
                                    (annotationMutationInProgress.value)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                                          _cache[23] || (_cache[23] = _createTextVNode(" Updating Code ", -1)),
                                          _createVNode(_unref(BSpinner), {
                                            small: "",
                                            label: ""
                                          })
                                        ]))
                                      : (annotationMutationShowSuccess.value)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                                            _cache[24] || (_cache[24] = _createTextVNode(" Samples Annotated ", -1)),
                                            _createVNode(_component_font_awesome_icon, {
                                              icon: ['fa', 'check-double'],
                                              class: "me-2"
                                            })
                                          ]))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_14, " Auto-Annotate Samples "))
                                  ]),
                                  _: 1
                                }, 8, ["disabled"]))
                              : _createCommentVNode("", true)
                          ], 8, _hoisted_11),
                          _createElementVNode("span", {
                            id: `btn-bcl-to-fastq-${storageBucket.value.id}`
                          }, [
                            (
                canEdit.value && storageBucket.value.dataType === _unref(BUCKET_DATA_TYPES).INPUT
              )
                              ? (_openBlock(), _createBlock(_unref(BButton), {
                                  key: 0,
                                  onClick: handleBclToFastq,
                                  variant: "primary",
                                  size: "sm",
                                  disabled: !bclToFastqEnabled.value
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_font_awesome_icon, { icon: "shuffle" }),
                                    _cache[25] || (_cache[25] = _createTextVNode(" BCL to FASTQ ", -1))
                                  ]),
                                  _: 1
                                }, 8, ["disabled"]))
                              : _createCommentVNode("", true)
                          ], 8, _hoisted_15),
                          _createVNode(_unref(BTooltip), {
                            target: `btn-auto-annotate-samples-${storageBucket.value.id}`
                          }, {
                            default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                              _createTextVNode(" This action will not modify already annotated samples or produce duplicates. Select specific files if you want to limit the scope of the operation. ", -1)
                            ]))]),
                            _: 1
                          }, 8, ["target"]),
                          _createVNode(_unref(BTooltip), {
                            target: `btn-new-sample-${storageBucket.value.id}`
                          }, {
                            default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                              _createTextVNode(" Select the R1 and R2 fastq files to manually annotate a sample ", -1)
                            ]))]),
                            _: 1
                          }, 8, ["target"]),
                          _createVNode(_unref(BTooltip), {
                            target: `btn-bcl-to-fastq-${storageBucket.value.id}`
                          }, {
                            default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                              _createTextVNode("Select BCL.tar archive file to enable this feature", -1)
                            ]))]),
                            _: 1
                          }, 8, ["target"])
                        ], 64))
                      : _createCommentVNode("", true),
                    (canEdit.value)
                      ? (_openBlock(), _createBlock(_unref(BButton), {
                          key: 1,
                          onClick: handleDataObjectsSelectionDelete,
                          variant: "primary",
                          size: "sm",
                          disabled: !selectedDataObjects.value.length,
                          hidden: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_font_awesome_icon, { icon: "trash" }),
                            _cache[29] || (_cache[29] = _createTextVNode(" Delete ", -1))
                          ]),
                          _: 1
                        }, 8, ["disabled"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["id"]))
              : _createCommentVNode("", true),
            _createVNode(_unref(BAlert), {
              modelValue: annotationMutationError.value,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((annotationMutationError).value = $event)),
              show: "",
              variant: "danger",
              dismissible: ""
            }, {
              default: _withCtx(() => [
                _createTextVNode(" An error occurred while auto annotating samples: " + _toDisplayString(annotationMutationError.value), 1)
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_unref(BAlert), {
              modelValue: noDataObjects.value,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((noDataObjects).value = $event)),
              variant: "secondary"
            }, {
              default: _withCtx(() => [...(_cache[30] || (_cache[30] = [
                _createTextVNode("No files found.", -1)
              ]))]),
              _: 1
            }, 8, ["modelValue"]),
            (selectableDataObjects.value.length > 0)
              ? (_openBlock(), _createBlock(_unref(BCard), { key: 3 }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(BTable), {
                      items: selectableDataObjects.value,
                      busy: _unref(loading),
                      fields: fileTableFields,
                      small: "",
                      responsive: "",
                      hover: "",
                      class: "browser-table",
                      onRowClicked: dataRowClicked
                    }, {
                      "cell(id)": _withCtx((data) => [
                        (data.item.isSelectable)
                          ? (_openBlock(), _createBlock(_unref(BFormCheckbox), {
                              key: 0,
                              size: "sm",
                              modelValue: data.item.selected,
                              "onUpdate:modelValue": ($event: any) => ((data.item.selected) = $event)
                            }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                          : _createCommentVNode("", true)
                      ]),
                      "cell(updatedAt)": _withCtx((data) => [
                        _createTextVNode(_toDisplayString(_unref(formatDate)(data.value, '-')), 1)
                      ]),
                      "cell(name)": _withCtx((data) => [
                        (data.item.isFolder)
                          ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                              key: 0,
                              icon: "folder",
                              class: "me-1 file-browser"
                            }))
                          : (_openBlock(), _createBlock(_component_font_awesome_icon, {
                              key: 1,
                              icon: "file-lines",
                              class: "me-1"
                            })),
                        _createTextVNode(" " + _toDisplayString(data.value), 1)
                      ]),
                      "cell(actions)": _withCtx((data) => [
                        _createVNode(_unref(BButtonGroup), { class: "action-buttons" }, {
                          default: _withCtx(() => [
                            (data.item.isFolder && data.item.name === '..')
                              ? (_openBlock(), _createBlock(_unref(BButton), {
                                  key: 0,
                                  size: "sm",
                                  variant: "outline-secondary",
                                  onClick: goUpOneFolder
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_font_awesome_icon, {
                                      icon: "arrow-left",
                                      class: "me-1"
                                    })
                                  ]),
                                  _: 1
                                }))
                              : (_openBlock(), _createBlock(_unref(BButton), {
                                  key: 1,
                                  size: "sm",
                                  variant: "outline-secondary",
                                  onClick: ($event: any) => (handleDataObjectDetailRequest(data.item, $event))
                                }, {
                                  default: _withCtx(() => [
                                    (data.item.isFolder)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_16, [
                                          _createVNode(_component_font_awesome_icon, {
                                            icon: "folder",
                                            class: "me-1"
                                          })
                                        ]))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_17, [
                                          _createVNode(_component_font_awesome_icon, {
                                            icon: "info-circle",
                                            class: "me-1"
                                          })
                                        ]))
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"])),
                            (
                  props.allowDownload &&
                  data.item.isSelectable &&
                  !data.item.isFolder
                )
                              ? (_openBlock(), _createBlock(_unref(BButton), {
                                  key: 2,
                                  size: "sm",
                                  variant: "outline-secondary",
                                  onClick: ($event: any) => (handleDataObjectDownloadRequest(data.item))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_font_awesome_icon, {
                                      icon: "download",
                                      class: "me-1"
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["onClick"]))
                              : _createCommentVNode("", true),
                            (canEdit.value && data.item.isSelectable)
                              ? (_openBlock(), _createBlock(_unref(BButton), {
                                  key: 3,
                                  size: "sm",
                                  variant: "outline-secondary",
                                  onClick: ($event: any) => (handleDataObjectRenameRequest(data.item))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_font_awesome_icon, {
                                      icon: "pencil",
                                      class: "me-1"
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["onClick"]))
                              : _createCommentVNode("", true),
                            (canEdit.value && data.item.isSelectable)
                              ? (_openBlock(), _createBlock(_unref(BButton), {
                                  key: 4,
                                  size: "sm",
                                  variant: "outline-secondary",
                                  onClick: ($event: any) => (handleDataObjectDeleteRequest(data.item))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_font_awesome_icon, {
                                      icon: "trash",
                                      class: "me-1"
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["onClick"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 1
                    }, 8, ["items", "busy"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (props.listComputeTasks)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _createElementVNode("h5", _hoisted_19, [
                    _createVNode(_component_font_awesome_icon, {
                      icon: "cogs",
                      class: "me-1"
                    }),
                    _cache[31] || (_cache[31] = _createTextVNode(" Compute Tasks ", -1))
                  ]),
                  _createVNode(ComputeTaskList, {
                    ref_key: "computeTaskList",
                    ref: computeTaskList,
                    parentName: "Data Browser",
                    "user-role": null,
                    bucketId: props.bucketId,
                    "paging-items-per-page": 0
                  }, null, 8, ["bucketId"])
                ]))
              : _createCommentVNode("", true),
            (props.listSamples && samples.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _createElementVNode("h5", _hoisted_21, [
                    _createVNode(_component_font_awesome_icon, {
                      icon: "flask",
                      class: "me-1"
                    }),
                    _cache[32] || (_cache[32] = _createTextVNode(" Samples ", -1))
                  ]),
                  _createVNode(SampleList, {
                    samples: samples.value,
                    loading: _unref(loading),
                    showBucket: false,
                    showKit: true,
                    showAssociatedProjects: false,
                    assocProjectId: null,
                    assocProjectName: null,
                    canEditSampleAssoc: false,
                    onRefresh: refreshRequested
                  }, null, 8, ["samples", "loading"]),
                  _createElementVNode("p", null, [
                    _cache[34] || (_cache[34] = _createTextVNode(" To process and analyze annotated samples, first create a project in ", -1)),
                    _createVNode(_component_router_link, { to: { name: 'Projects' } }, {
                      default: _withCtx(() => [...(_cache[33] || (_cache[33] = [
                        _createTextVNode("Project Manager", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[35] || (_cache[35] = _createTextVNode(" (if you haven't already), associate the samples with that project, and then start processing from within the project. Projects already linked to these samples are listed below. ", -1))
                  ])
                ]))
              : _createCommentVNode("", true),
            (props.listProjects && projects.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  _createElementVNode("h5", _hoisted_23, [
                    _createVNode(_component_font_awesome_icon, {
                      icon: "project-diagram",
                      class: "me-1"
                    }),
                    _cache[36] || (_cache[36] = _createTextVNode(" Projects ", -1))
                  ]),
                  _createVNode(ProjectList, {
                    projects: projects.value,
                    loading: _unref(loading),
                    canEdit: canEdit.value,
                    showOwner: false
                  }, null, 8, ["projects", "loading", "canEdit"])
                ]))
              : _createCommentVNode("", true),
            (canEdit.value)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
                  _createVNode(_unref(BButton), {
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (showAdvancedFeatures.value = !showAdvancedFeatures.value)),
                    class: "mt-4",
                    size: "sm",
                    variant: "outline-dark"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_font_awesome_icon, {
                        icon: "cogs",
                        class: "me-1"
                      }),
                      _cache[37] || (_cache[37] = _createTextVNode(" Advanced ", -1)),
                      _createVNode(_component_font_awesome_icon, {
                        icon: showAdvancedFeatures.value ? 'angle-down' : 'angle-right'
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(BCollapse), {
                    modelValue: showAdvancedFeatures.value,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((showAdvancedFeatures).value = $event))
                  }, {
                    default: _withCtx(() => [
                      (props.listUsers && !isSystemBucket.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                            _createElementVNode("h5", _hoisted_25, [
                              _createVNode(_component_font_awesome_icon, {
                                icon: "user-shield",
                                class: "me-1"
                              }),
                              _cache[38] || (_cache[38] = _createTextVNode(" Users & Sharing ", -1))
                            ]),
                            (storageBucket.value?.usersAssociated?.length === 0)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_26, " No users associated with this bucket. "))
                              : _createCommentVNode("", true),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(storageBucket.value?.usersAssociated, (assoc, idx) => {
                              return (_openBlock(), _createElementBlock(_Fragment, { key: idx }, [
                                (assoc && assoc.user)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_27, [
                                      _cache[40] || (_cache[40] = _createElementVNode("strong", null, "Role:", -1)),
                                      _createTextVNode(" " + _toDisplayString(assoc.userRole), 1),
                                      _cache[41] || (_cache[41] = _createElementVNode("br", null, null, -1)),
                                      _cache[42] || (_cache[42] = _createElementVNode("strong", null, "Name:", -1)),
                                      _createTextVNode(" " + _toDisplayString(assoc.user?.givenName) + " " + _toDisplayString(assoc.user?.familyName) + " ", 1),
                                      _cache[43] || (_cache[43] = _createElementVNode("br", null, null, -1)),
                                      _cache[44] || (_cache[44] = _createElementVNode("strong", null, "Email:", -1)),
                                      _createTextVNode(" " + _toDisplayString(assoc.user?.email), 1),
                                      _cache[45] || (_cache[45] = _createElementVNode("br", null, null, -1)),
                                      (canEdit.value && assoc.userRole !== 'owner')
                                        ? (_openBlock(), _createBlock(_unref(BButton), {
                                            key: 0,
                                            onClick: ($event: any) => (bucketUserAssociationDeleteRequested(assoc.user)),
                                            variant: "outline-danger",
                                            size: "sm"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_font_awesome_icon, {
                                                icon: ['fas', 'times'],
                                                class: "me-2"
                                              }),
                                              _cache[39] || (_cache[39] = _createTextVNode(" Remove ", -1))
                                            ]),
                                            _: 1
                                          }, 8, ["onClick"]))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ], 64))
                            }), 128)),
                            (canEdit.value)
                              ? (_openBlock(), _createBlock(_unref(BButton), {
                                  key: 1,
                                  onClick: _cache[10] || (_cache[10] = ($event: any) => (showBucketUserAssociationCreateModal.value = true)),
                                  variant: "secondary",
                                  size: "sm"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_font_awesome_icon, {
                                      icon: "user-plus",
                                      class: "me-1"
                                    }),
                                    _cache[46] || (_cache[46] = _createTextVNode(" Share data ", -1))
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (showBucketUserAssociationCreateModal.value)
                              ? (_openBlock(), _createBlock(BucketUserAssociationCreate, {
                                  key: 2,
                                  show: showBucketUserAssociationCreateModal.value,
                                  bucketId: props.bucketId,
                                  onClose: closeModals,
                                  onCloseAndRefresh: onBucketSharingChangedSuccess
                                }, null, 8, ["show", "bucketId"]))
                              : _createCommentVNode("", true),
                            (showBucketUserAssociationDeleteModal.value && selectedUser.value)
                              ? (_openBlock(), _createBlock(BucketUserAssociationDelete, {
                                  key: 3,
                                  show: showBucketUserAssociationDeleteModal.value,
                                  bucketId: props.bucketId,
                                  user: selectedUser.value,
                                  "bucket-friendly-name": storageBucket.value.friendlyName || '',
                                  onClose: closeModals,
                                  onCloseAndRefresh: onBucketSharingChangedSuccess
                                }, null, 8, ["show", "bucketId", "user", "bucket-friendly-name"]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                      (
              storageBucket.value.name &&
              __props.bucketId &&
              (_unref(IS_DEBUG_MODE) || _unref(userStore).developer)
            )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                            _createElementVNode("h5", _hoisted_29, [
                              _createVNode(_component_font_awesome_icon, {
                                icon: "info-circle",
                                class: "me-1"
                              }),
                              _cache[47] || (_cache[47] = _createTextVNode(" Debug Info ", -1))
                            ]),
                            _createElementVNode("p", null, [
                              _cache[48] || (_cache[48] = _createElementVNode("strong", null, "Bucket ID:", -1)),
                              _createTextVNode(" " + _toDisplayString(__props.bucketId), 1),
                              _cache[49] || (_cache[49] = _createElementVNode("br", null, null, -1)),
                              _cache[50] || (_cache[50] = _createElementVNode("strong", null, "Bucket name:", -1)),
                              _createTextVNode(" " + _toDisplayString(storageBucket.value.name), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (!isSystemBucket.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                            _createElementVNode("h5", _hoisted_31, [
                              _createVNode(_component_font_awesome_icon, {
                                icon: "trash",
                                class: "me-1"
                              }),
                              _cache[51] || (_cache[51] = _createTextVNode(" Delete Data ", -1))
                            ]),
                            _cache[53] || (_cache[53] = _createElementVNode("p", {
                              variant: "warning",
                              show: ""
                            }, [
                              _createElementVNode("strong", null, "Warning:"),
                              _createTextVNode(" This action is irreversible. All data associated with this bucket will be permanently deleted. ")
                            ], -1)),
                            _createVNode(_unref(BButton), {
                              onClick: _cache[11] || (_cache[11] = ($event: any) => (showBucketDeleteModal.value = true)),
                              variant: "danger",
                              size: "sm"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_font_awesome_icon, {
                                  icon: "trash",
                                  class: "me-1"
                                }),
                                _cache[52] || (_cache[52] = _createTextVNode(" Delete Data ", -1))
                              ]),
                              _: 1
                            }),
                            (showBucketDeleteModal.value)
                              ? (_openBlock(), _createBlock(BucketDelete, {
                                  key: 0,
                                  show: showBucketDeleteModal.value,
                                  bucketId: props.bucketId,
                                  bucketFriendlyName: storageBucket.value.friendlyName || '',
                                  onClose: closeModals,
                                  onCloseAndRefresh: onBucketDeletedSuccess
                                }, null, 8, ["show", "bucketId", "bucketFriendlyName"]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ], 64))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
    (
        selectedDataObject.value &&
        storageBucket.value &&
        storageBucket.value.name &&
        storageBucket.value.id
      )
      ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
          _createVNode(DataObjectDetail, {
            show: showModalDataObjectDetail.value,
            "data-object": selectedDataObject.value,
            "bucket-name": storageBucket.value.name,
            "bucket-id": storageBucket.value.id,
            "allow-download": selectedDataObjectPreviewEnabled.value,
            onClose: closeModals
          }, null, 8, ["show", "data-object", "bucket-name", "bucket-id", "allow-download"])
        ]))
      : _createCommentVNode("", true),
    (selectedDataObject.value && storageBucket.value && storageBucket.value.id)
      ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
          _createVNode(DataObjectRename, {
            "bucket-id": storageBucket.value.id,
            "data-object": selectedDataObject.value,
            show: showModalDataObjectRename.value,
            onClose: closeModals,
            onCloseAndRefresh: onDataObjectRenameSuccess
          }, null, 8, ["bucket-id", "data-object", "show"])
        ]))
      : _createCommentVNode("", true),
    (selectedDataObject.value && storageBucket.value && storageBucket.value.id)
      ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
          _createVNode(DataObjectDelete, {
            "bucket-id": storageBucket.value.id,
            "data-object": selectedDataObject.value,
            show: showModalDataObjectDelete.value,
            onClose: closeModals,
            onCloseAndRefresh: onDataObjectDeleteSuccess
          }, null, 8, ["bucket-id", "data-object", "show"])
        ]))
      : _createCommentVNode("", true),
    (
        newSampleEnabled.value &&
        storageBucket.value &&
        storageBucket.value.id &&
        showModalSampleCreate.value
      )
      ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
          _createVNode(SampleForm, {
            "bucket-id": storageBucket.value.id,
            "sample-id": null,
            "sample-name": newSampleName.value,
            "sample-description": newSampleDescription.value,
            "sample-file-r1": newSampleFileR1.value,
            "sample-file-r2": newSampleFileR2.value,
            "kit-code": newSampleKitCode.value,
            warning: newSampleWarning.value,
            error: newSampleError.value,
            show: showModalSampleCreate.value,
            onClose: closeModals,
            onCloseAndRefresh: onSampleFormSuccess
          }, null, 8, ["bucket-id", "sample-name", "sample-description", "sample-file-r1", "sample-file-r2", "kit-code", "warning", "error", "show"])
        ]))
      : _createCommentVNode("", true),
    (
        bclToFastqEnabled.value &&
        storageBucket.value &&
        storageBucket.value.id &&
        storageBucket.value.name &&
        conversionFileBcl.value &&
        showModalBclToFastq.value
      )
      ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
          _createVNode(BclToFastqNew, {
            "bucket-id": storageBucket.value.id,
            "bucket-name": storageBucket.value.name,
            "file-bcl": conversionFileBcl.value,
            "file-csv": conversionFileCsv.value,
            "default-name": conversionDefaultName.value,
            show: showModalBclToFastq.value,
            onClose: closeModals,
            onCloseAndRefresh: onBclToFastqSuccess
          }, null, 8, ["bucket-id", "bucket-name", "file-bcl", "file-csv", "default-name", "show"])
        ]))
      : _createCommentVNode("", true),
    (storageBucket.value && storageBucket.value.id && showBucketExpirationModal.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
          _createVNode(_unref(BModal), {
            modelValue: showBucketExpirationModal.value,
            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((showBucketExpirationModal).value = $event))
          }, {
            title: _withCtx(() => [
              _createVNode(_component_font_awesome_icon, {
                icon: "hourglass-end",
                class: "me-2"
              }),
              _cache[54] || (_cache[54] = _createTextVNode(" Data Expiration ", -1))
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                (storageBucket.value.expiresAt)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                      _createElementVNode("p", null, [
                        _cache[55] || (_cache[55] = _createTextVNode(" This data is set to expire on ", -1)),
                        _createElementVNode("strong", null, _toDisplayString(_unref(formatDate)(storageBucket.value.expiresAt)), 1),
                        _cache[56] || (_cache[56] = _createTextVNode(". ", -1))
                      ]),
                      _cache[57] || (_cache[57] = _createElementVNode("p", null, " When data expires, all files contained within it will be permanently deleted and cannot be recovered. ", -1)),
                      _cache[58] || (_cache[58] = _createElementVNode("p", null, " To extend the expiration date, please contact your account manager or our technical support team. ", -1))
                    ]))
                  : (_openBlock(), _createElementBlock("p", _hoisted_39, "This data is not set to expire."))
              ])
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})